"use client";

import React from "react";
import style from "./whatsApp.module.scss";
import { FaWhatsapp } from "react-icons/fa6";
import Link from "next/link";

interface WhatsAppProps {
    phoneNumber: string;
}

const WhatsApp = ({ phoneNumber }: WhatsAppProps) => {
    return (
        <Link id="whatsapp" className={style.whatsAppBtn} rel="nofollow" href={`https://wa.me/4${phoneNumber}`} aria-label="whatsapp">
            <FaWhatsapp />
        </Link>
    );
};

export default WhatsApp;
